import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'kyb-risk-badge',
  templateUrl: './kyb-risk-badge.component.html',
  styleUrls: ['./kyb-risk-badge.component.scss'],
  standalone: true,
  imports: [NgClass, MatTooltipModule],
})
export class KybRiskBadgeComponent {
  @Input() score: number | null = null;
  @Input() level: string | null = null;

  get hasScore(): boolean {
    return this.score != null && !Number.isNaN(Number(this.score));
  }

  get displayScore(): string {
    if (!this.hasScore) {
      return '—';
    }
    const n = Number(this.score);
    return Number.isInteger(n) ? String(n) : n.toFixed(1);
  }

  /** Colour from FrankieOne's riskLevel, never re-thresholded from the score. */
  levelClass(): string {
    const token = (this.level ?? '').trim().toLowerCase();
    if (!token) {
      return 'unknown';
    }
    if (token === 'low') {
      return 'low';
    }
    if (token === 'medium') {
      return 'medium';
    }
    if (token === 'high' || token === 'unacceptable') {
      return 'high';
    }
    return 'unknown';
  }
}
